module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    class: _vm.transparent,
    attrs: {
      "id": "loading"
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20fc8c51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/Loading.vue
// module id = 993
// module chunks = 1